import { createFileRoute, redirect } from "@tanstack/react-router";
import { listParties } from "@/features/parties/parties.api";

// Beheer → Organisatie is gone (S27): the organisation tree sits on the card of the
// relation marked as our own organisation. An old link lands on that tab, or on the
// relations list while no relation carries the mark.
export const Route = createFileRoute("/_shell/org")({
  beforeLoad: async ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: "/dashboard" });
    }
    const own = await listParties({ ownOrganization: "true" }).catch(() => null);
    const party = own?.data[0];
    if (party) {
      throw redirect({ to: "/parties/$id", params: { id: party.id }, search: { tab: "organization" } });
    }
    throw redirect({ to: "/parties", search: {} });
  },
});
